export default __webpack_public_path__ + "static/media/telegram.0cc2e421.svg";